import { render, staticRenderFns } from "./bind-email.vue?vue&type=template&id=e7075b56&scoped=true&"
import script from "./bind-email.vue?vue&type=script&lang=js&"
export * from "./bind-email.vue?vue&type=script&lang=js&"
import style0 from "./bind-email.vue?vue&type=style&index=0&id=e7075b56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7075b56",
  null
  
)

export default component.exports